import Big from 'big.js';

import { falseExceptZero } from 'app/utils/ObjectUtils';

/**
 * Страховой продукт
 */
export class InsuranceProduct {
    /**
     * Код
     */
    code: string;

    /**
     * Наименование
     */
    name: string;

    /**
     * Идентификатор страховой организации
     */
    organizationId: string;

    /**
     * Наименование страховой организации
     */
    organizationName: string;

    /**
     * Страховой взнос
     */
    amount: Big;

    /**
     * Трёхбуквенный код валюты страхового взноса
     */
    currency: string;

    /**
     * Срок страхования (месяцы)
     */
    term: number;

    /**
     * Код документа с условиями страхования
     */
    conditionsDocumentCode: string;

    /**
     * Минимальная сумма кредита (CreditCardOrder.amount) при которой  пользователь может приобрести страховой продукт.
     * Ограничение необходимо, чтобы пользователь не потратил всю сумму кредита на покупку кредитного продукта.
     * Данное значение должно быть больше amount.
     */
    minCreditAmount: number;

    static deserialize(data: any) {
        return Object.assign(new InsuranceProduct(), data, {
            amount: falseExceptZero(data.amount) ? new Big(data.amount) : null,
        });
    }
}
